// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"375":"repo","414":"image","529":"package","543":"data","878":"generic"}[chunkId] + "." + {"375":"427dd2f7","414":"bccf96f0","529":"427dd2f7","543":"427dd2f7","878":"427dd2f7"}[chunkId] + ".css";
};